import React, { Fragment, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Desktopnav from './Desktopnav';
import SearchBar from '../SearchBar/SearchBar';
import './Header.css';


function Header() {
  const [scrolled, setScrolled] = useState(false);
  const Logo = `${process.env.REACT_APP_URL_ASSETS}Assets/Logo.png`

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  return (
    <Fragment>
      <header className={`main-header ${scrolled ? 'header-scrolled' : ''}`}>
        <div className='header-container'>
          {/* Logo Section */}
          <div className='header-logo'>
            <Link to="/" onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); }}>
              <img src={Logo} alt='Salaam Takaful Logo' />
            </Link>
          </div>

          {/* Desktop Navigation & Search */}
          <div className='header-nav-wrapper desktop'>
            <Desktopnav />
            <div className='header-search'>
              <SearchBar />
            </div>
          </div>

          {/* Mobile Controls */}
          <div className='header-mobile-controls mobile'>
            <div className='mobile-search-btn'>
              <SearchBar />
            </div>
            <Link 
              to='/sidebar' 
              className='mobile-menu-btn' 
              onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); }}
              aria-label="Open Menu"
            >
              <span className='hamburger-icon'>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </Link>
          </div>
        </div>
      </header>
    </Fragment>
  )
}

export default Header